import React from 'react';
import TickIcon, { TickIconProps } from './Tick';

export default function GreenTickIcon(props: TickIconProps): JSX.Element {
  return <TickIcon style={{ color: '#3aa104' }} {...props} />;
}
